import { fromPairs } from 'remeda';

import type { ColumnsSettings } from './types';

export function makeInitialColumnSettings<K extends string>(columns: K[], requiredColumns: K[] = []) {
  const initialSettings = fromPairs(
    columns.map((field, index) => [
      field,
      { isShow: true, index: index + 1, required: requiredColumns.includes(field) },
    ]),
  );

  return initialSettings as unknown as ColumnsSettings<K>;
}
